import { useAuth0 } from "ct-auth"
import React, { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { auth0ErrorsFromParamString } from "../../data-utils/authUtils.js"
import logger from "../../Logger/index.js"
import ErrorPage from "../Errors/error-page"

const pageLogger = logger.child({ module: "AuthenticationError" })
export const AuthenticationErrorWrapper = ({ children }) => {
  const { isAuthenticated, user, logout } = useAuth0()
  const location = useLocation()
  const logoutTriggered = useRef(false)

  // Check for Auth0 callback URL errors in both hash params and query params
  const hashErrors = auth0ErrorsFromParamString(location?.hash?.replaceAll("#", ""))
  const queryErrors = auth0ErrorsFromParamString(location?.search?.replaceAll("?", ""))
  const error = hashErrors.error || queryErrors.error
  const description = hashErrors.description || queryErrors.description
  const showRequestNewInvitation = hashErrors.showRequestNewInvitation || queryErrors.showRequestNewInvitation

  // Show the error if the current user doesn't already have a valid login session
  const showError = (error || description) && (!isAuthenticated || !user)

  // Clear Auth0 session on access_denied to prevent silent re-auth loop via HRD
  useEffect(() => {
    if (showError && !logoutTriggered.current && (queryErrors.error || hashErrors.error)) {
      const rawDesc = new URLSearchParams(location?.search).get('error_description') ||
        new URLSearchParams(location?.hash?.replaceAll('#', '')).get('error_description')
      if (rawDesc === 'not_authorized' || rawDesc === 'no_org' || rawDesc === 'server_error') {
        logoutTriggered.current = true
        logout({ logoutParams: { returnTo: window.location.href } })
      }
    }
  }, [showError, logout, location, queryErrors.error, hashErrors.error])

  if (showError) {
    pageLogger.info({ error, description, authStatus: isAuthenticated, userData: user }, 'Authentication Error Data')
  }
  return showError ? <ErrorPage title={error} message={description} showRequestNewInvitation={showRequestNewInvitation} /> : children
}
